import { GET_CONTRACT_TYPE_AND_PROVIDERS_FOR_APPROVER } from "src/api-setup/api-endpoints";
import { generateHeader, POSTAPI } from "src/api-setup/api-helper";

export const getAllApproverDropdown = async (cookiesData, dispatch) => {
  if (!cookiesData) return [];
  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_approver_mstr_key: cookiesData.out_user_id,
      in_sort_number: 1,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(
      false,
      GET_CONTRACT_TYPE_AND_PROVIDERS_FOR_APPROVER,
      null,
      apiHeaders,
      requestBody,
      dispatch
    );

    return response;
  } catch (error) {
    console.error("Error fetching all providers:", error);
    return [];
  }
};
